export default __webpack_public_path__ + "media/components/Pages/Index/Images/bulletin-85049985c924190790caaf9a6cf2d343.jpg";